import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PushPinIcon from "@mui/icons-material/PushPin";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import Title from "../../../Title";
import ReprogramarPedido from "./ReprogramarPedido";

function ReclamarPedido(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [dialogDecide, setdialogDecide] = useState(true)
  const [datosformulario, setDatosformulario] = useState(props.dataPedido);
  const [disBtn, setDisBtn] = useState(false);
  const [reprogramar, setReprogramar] = useState(false)
  const [datosPedido, setdatosPedido] = useState({
    observaciones: "",
  });

  async function guardar(e) {
    setDisBtn(true);
    putData(
      e,
      "/envasado_pedidos/" + datosformulario.id,
      {
        reclamado: 1,
        obs_reclamo: datosPedido.observaciones
      },
      setNotificacion
    );
  }

  const handleClickReprogramar = () =>{
    setReprogramar(true)
    setdialogDecide(false)
  }

  const handleCloseReprogramar = () =>{
    setReprogramar(false)
    handleClose()
  }

  const handleClose = () => {
    props.setOpen(false);
  };

    const almacenar = (e) => {
    setdatosPedido({
      ...datosPedido,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.setOpen(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      {dialogDecide &&(
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="sm"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
                    <DialogTitle>
                      <Typography variant="h6" align="center" color="#ffffff">
                        Reclamar Pedido N° {datosformulario.id}
                      </Typography>
                    </DialogTitle>
                  </Box>
        <DialogContent sx={{ alignContent: "center" }}>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                label="Observaciones"
                name="observaciones"
                size="small"
                focused
                fullWidth
                autoComplete="off"
                value={datosPedido.observaciones}
                onChange={almacenar}
              />
            </Grid>
          </Grid>

          <Grid
            mt={1}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              disabled={disBtn}
              variant="contained"
              onClick={handleClose}
              color="error"
            >
              Volver
            </Button>
            <Button
              disabled={disBtn || datosPedido.observaciones === ""}
              variant="contained"
              onClick={guardar}
              color="success"
            >
              Guardar
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
      )}
      {reprogramar && (
        <ReprogramarPedido
          open={reprogramar}
          setOpen={handleCloseReprogramar}
          dataPedido={datosformulario}
        />
      )}
    </div>
  );
}

export default ReclamarPedido;
